import React, {useState} from "react";
import S360WidgetContainer from "root/s360components/LearningJournal/S360WidgetContainer";
import HookSubFormSchoolGroupPupil, {
    LunchReportPersonsNames,
    lunchReportPersonsSelected, SchoolGroupPupilOffsets
} from "root/s360components/LunchReport/HookSubFormSchoolGroupPupil";
import HookSubFormCustomDateRange, {
    lunchReportDateRangeDefaults, LunchReportsDateRangeLimits
} from "root/s360components/LunchReport/HookSubFormCustomDateRange";
import {useForm} from "react-hook-form";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import format from "date-fns/format";
import {getSchoolLunchReport} from "root/DataFunctions/ReportDataFns";
import useModalLunchReport, {ModalLunchReportModes} from "root/s360components/Modals/LunchReport/useModalLunchReport";
import {isAfter} from "date-fns";


export const LunchReportFormSections = {
    PEOPLE: 'people',
    DATES: 'dates'
}
const LunchReportPage = ({school_id, rval}) =>
{

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    //Shows which side menu to have open when here
    const menu = urlParams.get('menu');

    const [disabledButton, setDisabledButton] = useState(false);

    const [renderModalLunchReport, activateModalLunchReport] = useModalLunchReport();

    const backLink = "/eyfs_admin.php?page=form_att_reports_n&menu=" + menu;


    const {register, control, handleSubmit, setFocus, watch, setValue, getValues, reset, resetField, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ...lunchReportPersonsSelected(),
                ...lunchReportDateRangeDefaults()
            }
        });

    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        reset: reset,
        resetField: resetField,
        formErrors: formErrors,
        setValue: setValue,
        getValues: getValues
    }

    const buildFormData = (data, formattedDates) =>
    {
        //+1 as the ajaxSchoolLunchRep function uses the reptype from 1-3 instead of 0-2
        const personsFilter = data[LunchReportFormSections.PEOPLE][LunchReportPersonsNames.FILTER] + 1;

        return {
            reptype: +personsFilter,
            s_date: formattedDates.start_date,
            e_date: formattedDates.end_date,
            schoolId: school_id,
            classId: data[LunchReportFormSections.PEOPLE][LunchReportPersonsNames.CLASS] !== null ? data[LunchReportFormSections.PEOPLE][LunchReportPersonsNames.CLASS].value : null,
            studentId: data[LunchReportFormSections.PEOPLE][LunchReportPersonsNames.PUPIL] !== null ? data[LunchReportFormSections.PEOPLE][LunchReportPersonsNames.PUPIL].value : null,
        }
    }

    const openLunchPdf = (pdfFilePath) =>
    {
        window.open(pdfFilePath);
    }

    const validateDatesOrder = (formattedDates, start_date, end_date) =>
    {
        return formattedDates.start_date === formattedDates.end_date ? true : isAfter(start_date, end_date);
    }

    const onSubmit = (data) =>
    {

        const formattedDates = {start_date: format(data[LunchReportFormSections.DATES][LunchReportsDateRangeLimits.START], 'dd-MM-yyyy'),
                                                                end_date: format(data[LunchReportFormSections.DATES][LunchReportsDateRangeLimits.END], 'dd-MM-yyyy')};

        const validDates = validateDatesOrder(formattedDates, data[LunchReportFormSections.DATES][LunchReportsDateRangeLimits.END], data[LunchReportFormSections.DATES][LunchReportsDateRangeLimits.START]);

        if (validDates === false)
        {
            activateModalLunchReport({
                mode: ModalLunchReportModes.VALIDATE,
                message: "Your chosen start date is after your end date - Amend and resubmit"
            });
        }
        else
        {

            setDisabledButton(true);

            const formData = buildFormData(data, formattedDates);

            getSchoolLunchReport(formData, (response) =>
            {
                activateModalLunchReport({mode: ModalLunchReportModes.VIEW});

                openLunchPdf(response.error);

                setDisabledButton(false);

            }, (error, errMessage) =>
            {
                activateModalLunchReport({
                    mode: ModalLunchReportModes.ERROR,
                    error: error,
                    message: errMessage.toString()
                });

                setDisabledButton(false);
            });

        }
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    return (
        <S360WidgetContainer style={{minHeight: '600px'}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <HookSubFormSchoolGroupPupil school_id={school_id} {...controlProps} sectionName={LunchReportFormSections.PEOPLE}/>
                <HookSubFormCustomDateRange {...controlProps} sectionName={LunchReportFormSections.DATES} readOnly={false}/>

                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <div className='modal-button-row'>
                            <a href={backLink}><button type="button" className="btn btn-primary btn-icon glyphicons leaf"><i></i>Back</button></a>
                            <button disabled={disabledButton} type="button" className="btn btn-success btn-icon glyphicons leaf" onClick={onClickSaveForm}><i></i>Run Report</button>
                        </div>
                    </BootstrapCol>
                </BootstrapRow>
            </form>
            {renderModalLunchReport()}
        </S360WidgetContainer>
    )
}

export default LunchReportPage;